import './productOptions.scss';

import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useTranslation } from 'react-i18next';


import ProductOptionItem from './ProductOptionItem';
import ProductSubTitle from './ProductSubTitle';
import classNames from 'classnames';
import useMobileDetect from '../../hooks/useMobileDetect';


type DisplayOptions = {
    product: Queries.ProductsJson;
    option: Queries.ProductsJsonOptions;
};

type ProductOptionsProps = {
    className: string;
    options: Queries.ProductsJsonOptions[];
    lang: string;
};

export default function ProductOptions(props: ProductOptionsProps) {
    const { options, lang, className } = props;
    const isMobile = useMobileDetect().isMobile();

    const maxTile = isMobile ? 2 : 3;

    const allProducts = useStaticQuery(
        graphql`
            {
                allProductsJson {
                    nodes {
                        code
                        slug {
                            en_CA
                            en_US
                            fr_CA
                        }
                        images
                        fields {
                            ...productsFieldsImagesFragment
                        }
                    }
                }
            }
        `
    );
    const products = allProducts.allProductsJson.nodes;
    const { t } = useTranslation('templatePages');

    const [optionIndex, setOptionIndex] = useState(0);
    const [displayOptions, setDisplayOptions] = useState<DisplayOptions[]>([]);
    const showArrow = options.length <= maxTile ? false : true;

    useEffect(() => {
        const newDisplayOptions: DisplayOptions[] = [];
        for (
            let i = optionIndex;
            i < options.length && newDisplayOptions.length < maxTile;
            i++
        ) {
            const product = products.find(
                (product: Queries.ProductsJson) =>
                    product.code === options[i].code
            );

            if (product) {
                newDisplayOptions.push({
                    option: options[i],
                    product: product,
                });
            }
        }

        setDisplayOptions(newDisplayOptions);
    }, [optionIndex, options]);

    return (
        <div className={`product_options_container container ${className}`}>
            <ProductSubTitle textKey='options-title' />

            <div className='product_options_listing row'>
                {displayOptions.map(
                    (displayOption: DisplayOptions, index: number) => (
                        <ProductOptionItem
                            displayOption={displayOption}
                            lang={lang}
                            key={`opt${index}`}
                        />
                    )
                )}

                <div
                    className={classNames('option-prev option-nav', {
                        'd-none': !showArrow,
                    })}
                >
                    <span
                        className={
                            optionIndex !== 0
                                ? 'iconfont iconfont-prev'
                                : 'iconfont iconfont-prev not-clickable'
                        }
                        onClick={() =>
                            optionIndex !== 0 && setOptionIndex(optionIndex - 1)
                        }
                    />
                </div>
                <div
                    className={classNames('option-next option-nav', {
                        'd-none': !showArrow,
                    })}
                >
                    <span
                        className={
                            optionIndex < options.length - maxTile
                                ? 'iconfont iconfont-next'
                                : 'iconfont iconfont-next not-clickable'
                        }
                        onClick={() =>
                            optionIndex < options.length - maxTile &&
                            setOptionIndex(optionIndex + 1)
                        }
                    />
                </div>
            </div>
        </div>
    );
}
